// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__He5xE","dark":"tag_dark__3+Dpk","light":"tag_light__pzE4X"};